import { render, staticRenderFns } from "./PersistResponsavelUsuarioView.vue?vue&type=template&id=a8b34e30&"
import script from "./PersistResponsavelUsuarioView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelUsuarioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports